import { Alert } from '@mui/material';
import React, { memo } from 'react';
import css from './Alert.module.scss';

interface ComponentProps {
    /**
     * Determines alert color and icon
     */
    type: 'error' | 'info';
    /**
     * Text do display in alert
     */
    text: string;
}

export const GMAlert: React.FC<ComponentProps> = memo(({ type, text }) => {
    return (
        <Alert
            className={css.root}
            severity={type}
        >
            {text}
        </Alert>
    );
});